import { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartContext = createContext(null);
const STORAGE_KEY = "maison_luxe_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState([]);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (raw) setItems(JSON.parse(raw));
    } catch (e) { /* ignore */ }
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (product, opts = {}) => {
    const key = `${product.id}-${opts.length ?? ""}-${opts.density ?? ""}-${opts.color ?? ""}`;
    setItems((prev) => {
      const found = prev.find((i) => i.key === key);
      if (found) {
        return prev.map((i) => i.key === key ? { ...i, quantity: i.quantity + (opts.quantity || 1) } : i);
      }
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          slug: product.slug,
          title: product.title,
          image: product.image,
          price: opts.price ?? product.price,
          quantity: opts.quantity || 1,
          length: opts.length ?? product.length_inches,
          density: opts.density ?? product.density,
          color: opts.color ?? (product.colors?.[0] || ""),
          lace_type: opts.lace_type ?? product.lace_type,
        },
      ];
    });
    setDrawerOpen(true);
  };

  const updateQty = (key, qty) => {
    setItems((prev) => prev.map((i) => i.key === key ? { ...i, quantity: Math.max(1, qty) } : i));
  };
  const removeItem = (key) => setItems((prev) => prev.filter((i) => i.key !== key));
  const clear = () => setItems([]);

  const { count, subtotal } = useMemo(() => {
    let c = 0, s = 0;
    for (const i of items) { c += i.quantity; s += i.price * i.quantity; }
    return { count: c, subtotal: s };
  }, [items]);

  return (
    <CartContext.Provider value={{
      items, count, subtotal, drawerOpen, setDrawerOpen,
      addItem, updateQty, removeItem, clear,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
